import React from 'react';
import { motion } from 'framer-motion';
import { Truck } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const ShippingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50/50 to-white">
      {/* Header */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-br from-pink-100 to-rose-100 py-16"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", delay: 0.2 }}
            className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-6"
          >
            <Truck className="text-pink-500" size={32} />
          </motion.div>
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" 
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Shipping Information
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-lg text-gray-600 italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Fast, reliable delivery to your door
          </motion.p>
        </div>
      </motion.div>

      {/* Content */}
      <motion.div 
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
      >
        <motion.div variants={fadeInUp} className="prose prose-pink max-w-none">
          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Free Shipping</h2>
            <p className="text-gray-600 leading-relaxed">
              Enjoy free standard shipping on all orders over $50 within the United States! Orders under 
              $50 have a flat rate shipping fee of $5.99. We ship from Arizona and most orders arrive 
              within 5-7 business days.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Processing Time</h2>
            <p className="text-gray-600 leading-relaxed">
              Orders are processed within 1-2 business days. You'll receive a confirmation email with 
              tracking information once your order ships. Please note that orders placed on weekends 
              or holidays will be processed on the next business day.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Expedited Shipping</h2>
            <p className="text-gray-600 leading-relaxed">
              Need your order faster? We offer expedited shipping options at checkout. Express shipping 
              (2-3 business days) is available for an additional fee. Contact us at thepinkedit@yahoo.com 
              if you have any special shipping requests.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Order Tracking</h2>
            <p className="text-gray-600 leading-relaxed">
              Once your order ships, you'll receive an email with your tracking number. You can use this 
              to track your package's journey right to your doorstep. If you have any questions about 
              your shipment, don't hesitate to reach out!
            </p>
          </motion.section>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ShippingPage;
